import { simulateEnforcement } from "./sandboxEnforcer.js";

/**
 * In-memory decision log for replay / “why was X blocked?” (no server).
 */

/** @typedef {import('./types.js').DecisionLogEntry} DecisionLogEntry */
/** @typedef {import('../domain/types.js').EnforcementPlan} EnforcementPlan */
/** @typedef {import('./types.js').SimulatedEnforcementResult} SimulatedEnforcementResult */

const MAX = 200;
/** @type {DecisionLogEntry[]} */
const entries = [];

/**
 * @param {EnforcementPlan} input
 * @param {SimulatedEnforcementResult} output
 */
export function appendDecisionLog(input, output) {
  entries.unshift({
    timestamp: Date.now(),
    input: JSON.parse(JSON.stringify(input)),
    output: JSON.parse(JSON.stringify(output)),
  });
  while (entries.length > MAX) entries.pop();
}

/** @returns {DecisionLogEntry[]} */
export function snapshotDecisionLog() {
  return entries.map((e) => JSON.parse(JSON.stringify(e)));
}

export function clearDecisionLog() {
  entries.length = 0;
}

/**
 * Re-run sandbox simulation from a stored entry (deterministic if engine unchanged).
 * @param {DecisionLogEntry} log
 * @param {import('./sandboxEnforcer.js').SimulateOptions} [options]
 */
export function replay(log, options = {}) {
  return simulateEnforcement(log.input, options);
}

/**
 * @param {number} index 0 = newest
 */
export function replayAt(index, options = {}) {
  const e = entries[index];
  if (!e) return null;
  return replay(e, options);
}
